import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Apiservice } from '../../../../services/ApiService';
import { Performance } from '../../../../models/performance.model';

@Component({
  selector: 'app-edit-performance',
  templateUrl: './edit-performance.component.html',
  standalone: false,
  styleUrls: ['../add-performance/add-performance.component.scss']
})
export class EditPerformanceComponent implements OnInit {
  @Input() venueID: string = '';
  @Input() venueTimezone: string = '';
  @Input() performance!: Performance;
  @Output() saved = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  description = '';

  saving = false;
  validationError = '';
  saveError = '';

  constructor(private apiservice: Apiservice) {}

  ngOnInit(): void {
    this.description = this.performance?.description ?? '';
  }

  cancel() {
    this.cancelled.emit();
  }

  onBackdropClick(event: MouseEvent) {
    if (event.target === event.currentTarget && !this.saving) {
      this.cancel();
    }
  }

  get displayDate(): string {
    if (!this.performance) { return ''; }
    const tz = this.venueTimezone || 'UTC';
    return new Intl.DateTimeFormat('en-AU', {
      timeZone: tz,
      weekday: 'short',
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).format(new Date(Number(this.performance.item) * 1000));
  }

  get displayTime(): string {
    if (!this.performance) { return ''; }
    const tz = this.venueTimezone || 'UTC';
    return new Intl.DateTimeFormat('en-AU', {
      timeZone: tz,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).format(new Date(Number(this.performance.item) * 1000));
  }

  save() {
    this.validationError = this.validate();
    if (this.validationError) { return; }

    const trimmed = this.description.trim();
    if (trimmed === (this.performance.description ?? '')) {
      this.cancelled.emit();
      return;
    }

    this.saving = true;
    this.saveError = '';

    this.apiservice.postPerformance({
      venueID: this.venueID,
      timestamp: Number(this.performance.item),
      description: trimmed,
      status: this.performance.status,
      hiddenEvents: this.performance.hiddenEvents ?? [],
      customArchticsEvents: this.performance.customArchticsEvents ?? [],
      customHostEvents: this.performance.customHostEvents ?? [],
      eventScanMeta: this.performance.eventScanMeta ?? {}
    }).subscribe({
      next: () => {
        this.saving = false;
        this.saved.emit();
      },
      error: (err) => {
        this.saving = false;
        this.saveError = typeof err?.error === 'string'
          ? err.error
          : (err?.error?.message || err?.message || 'Failed to update performance.');
      }
    });
  }

  private validate(): string {
    if (!this.venueID) { return 'A venue must be selected.'; }
    if (!this.performance) { return 'Performance is missing.'; }
    if (!this.description.trim()) { return 'Description cannot be empty.'; }
    return '';
  }
}
